"use client";
// @ts-strict-ignore
import styled from "styled-components";

export const ContentBox = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  border-radius: 16px;
  flex-direction: column;
  margin: 48px 0px 48px;
  & * {
    box-sizing: border-box;
  }
  p {
    color: ${(props) => `${props?.theme.colorPalette.black}`};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin: 0px 0px 16px;
    a {
      color: ${(props) => `${props?.theme.colorPalette.black}`};
    }
  }
`;
